import { Reveal } from "../../common/reveal";
import { motion } from "framer-motion";
import { FaReact, FaNodeJs, FaPhp, FaAws, FaDocker, FaGitAlt, FaJava, FaAndroid, FaBootstrap, FaCss3Alt, FaHtml5, FaJsSquare, FaLaravel, FaCode } from "react-icons/fa";
import { SiFlutter, SiTailwindcss, SiExpress, SiMysql, SiJquery } from "react-icons/si";

const techs = [
  { name: "React", icon: <FaReact className="text-cyan-500" /> },
  { name: "React Native", icon: <FaReact className="text-cyan-500" /> },
  { name: "Flutter", icon: <SiFlutter className="text-blue-500" /> },
  { name: "Laravel", icon: <FaLaravel className="text-red-600" /> },
  { name: "Yii2", icon: <FaCode className="text-gray-500" /> },
  { name: "Bootstrap", icon: <FaBootstrap className="text-purple-600" /> },
  { name: "TailwindCSS", icon: <SiTailwindcss className="text-teal-500" /> },
  { name: "JavaScript", icon: <FaJsSquare className="text-yellow-500" /> },
  { name: "jQuery", icon: <SiJquery className="text-blue-600" /> },
  { name: "Node.js", icon: <FaNodeJs className="text-green-600" /> },
  { name: "Express.js", icon: <SiExpress className="text-gray-500" /> },
  { name: "PHP", icon: <FaPhp className="text-purple-700" /> },
  { name: "MySQL", icon: <SiMysql className="text-blue-700" /> },
  { name: "Git", icon: <FaGitAlt className="text-orange-600" /> },
  { name: "AWS", icon: <FaAws className="text-orange-400" /> },
  { name: "Docker", icon: <FaDocker className="text-blue-500" /> },
  { name: "HTML5", icon: <FaHtml5 className="text-orange-500" /> },
  { name: "CSS3", icon: <FaCss3Alt className="text-blue-500" /> },
  { name: "Java", icon: <FaJava className="text-red-700" /> },
  { name: "Android", icon: <FaAndroid className="text-green-700" /> },
];

export const TechStack = () => {
  return (
    <Reveal>
      <section id="stack" className="py-16 px-4 bg-white text-gray-800 rounded-xl max-w-6xl mx-auto relative overflow-hidden">
        {/* Subtle background floating blobs */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-pink-100/20 rounded-full blur-[100px] animate-pulse-slow" />
          <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-blue-100/20 rounded-full blur-[100px] animate-pulse-slow delay-2000" />
        </div>

        <h2 className="text-4xl font-extrabold mb-12 text-center bg-clip-text text-transparent bg-gradient-to-r from-cyan-500 via-purple-400 to-pink-500">Technologies I Work With</h2>

        <div className="flex flex-wrap justify-center gap-6 relative z-10">
          {techs.map(({ name, icon }, i) => (
            <motion.div key={name} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05, duration: 0.5 }} className="flex items-center space-x-3 bg-gray-50 rounded-xl px-4 py-2 shadow-md hover:shadow-xl hover:scale-105 transition-transform duration-300 cursor-default select-none border border-gray-100">
              <div className="text-3xl">{icon}</div>
              <span className="text-lg font-semibold text-gray-800">{name}</span>
            </motion.div>
          ))}
        </div>

        <style jsx>{`
          .animate-pulse-slow {
            animation: pulse 8s ease-in-out infinite;
          }
          @keyframes pulse {
            0%,
            100% {
              transform: scale(1);
              opacity: 0.3;
            }
            50% {
              transform: scale(1.05);
              opacity: 0.5;
            }
          }
        `}</style>
      </section>
    </Reveal>
  );
};
